import { TicketsProvider } from 'hooks/tickets'

const TicketProvider = ({ children }) => {
	return (
		<TicketsProvider>{children}</TicketsProvider>
	)
}

export default TicketProvider
